import React, { useState, useMemo } from 'react';
import {
  Container,
  Box,
  Typography,
  Grid,
  Alert,
  CircularProgress,
} from '@mui/material';
import dayjs from 'dayjs';
import 'dayjs/locale/it';

import { useAuth } from '../../contexts/AuthContext';
import Calendar from '../teacher/Calendar';
import NextCourses from '../teacher/NextCourses';
import CalendarList from '../teacher/CalendarList';

// Set Italian locale
dayjs.locale('it');

const MemberCalendar = () => {
  const [selectedDate, setSelectedDate] = useState(dayjs());
  const { user } = useAuth();

  // Extract courses from active user enrollments
  const memberCourses = useMemo(() => {
    if (!user?.enrollments || !Array.isArray(user.enrollments)) return [];

    return user.enrollments
      .filter(enrollment => 
        enrollment.status !== 'suspended' && 
        enrollment.course && 
        enrollment.course.status !== 'deleted'
      )
      .map(enrollment => enrollment.course);
  }, [user?.enrollments]);

  if (!user) {
    return (
      <Container maxWidth="xl">
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
          <CircularProgress />
        </Box>
      </Container>
    );
  }

  return (
    <Container maxWidth="xl" sx={{ py: 4, px: { xs: 0, sm: 3 } }}>
      <Box sx={{ py: 4 }}>
        <Typography variant="h4" gutterBottom>
          Il Mio Calendario
        </Typography>

        {memberCourses.length === 0 ? (
          <Alert severity="info" sx={{ mb: 2 }}>
            Non sei iscritto a nessun corso. Vai alla sezione "Corsi" per iscriverti.
          </Alert>
        ) : (
          <Grid container spacing={3} sx={{ mb: 4 }}>
            <Grid size={{ xs: 12, md: 4 }}>
              <Calendar 
                courses={memberCourses}
                selectedDate={selectedDate}
                onDateSelect={setSelectedDate}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 4 }}>
              <CalendarList 
                courses={memberCourses}
                selectedDate={selectedDate}
                onCourseClick={() => {}} // No navigation for members
                isClickable={false}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 4 }}>
              <NextCourses 
                courses={memberCourses}
                onCourseClick={() => {}} // No navigation for members
                isClickable={false}
              />
            </Grid>
          </Grid>
        )}
      </Box>
    </Container>
  );
};

export default MemberCalendar; 